import { post } from "@src/appV2/api/api";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const createOrUpdateLiveActivityRequestSchema = z.object({
  data: z.object({
    type: z.literal("liveActivity"),
    attributes: z.object({
      activityId: z.string(),
      platform: z.literal("ios"),
      activityPushToken: z.string(),
      status: z.literal("active"),
      shiftId: z.string(),
      workerId: z.string(),
    }),
  }),
});

const createOrUpdateLiveActivityResponseSchema = z.object({
  data: z.object({
    id: z.string(),
    type: z.literal("liveActivity"),
  }),
});

export type CreateOrUpdateLiveActivityRequest = z.infer<
  typeof createOrUpdateLiveActivityRequestSchema
>;
export type CreateOrUpdateLiveActivityResponse = z.infer<
  typeof createOrUpdateLiveActivityResponseSchema
>;

export function useCreateOrUpdateLiveActivity(
  options: UseMutationOptions<
    CreateOrUpdateLiveActivityResponse,
    AxiosError,
    CreateOrUpdateLiveActivityRequest
  > = {}
): UseMutationResult<
  CreateOrUpdateLiveActivityResponse,
  AxiosError,
  CreateOrUpdateLiveActivityRequest
> {
  return useMutation({
    mutationFn: async (data: CreateOrUpdateLiveActivityRequest) => {
      const response = await post({
        url: "/live-activities",
        data,
        requestSchema: createOrUpdateLiveActivityRequestSchema,
        responseSchema: createOrUpdateLiveActivityResponseSchema,
      });

      return response.data;
    },
    ...options,
  });
}
